import { useRestPost, UseRestPostMutationOptions } from 'scbk-services';
import { APIS } from 'scbk-shared-module/constants';

import type { UsrHelpLoginAuthSateResponse, UsrHelpLoginAuthSateRequest } from '../../types/api/usrHelpLoginAuthSateType'

/**
 * 로그인 or 인증 여부
 * @param mutationOptions
 * @returns
 */
export function useUsrHelpLoginAuthSate(
    mutationOptions?: UseRestPostMutationOptions<
        UsrHelpLoginAuthSateRequest,
        UsrHelpLoginAuthSateResponse
    >,
) {
    return useRestPost<UsrHelpLoginAuthSateRequest, UsrHelpLoginAuthSateResponse>(
        {
            endpoint: APIS.auth.user.help.checkLoginOrAuth,
        },
        mutationOptions,
    );
}